import { Spin } from "antd";
import { useState, useEffect } from "react";

import {
  // CatAndSubCatNav,
  CourseTopLevelCA,
  CourseTopLevel,
  // CatAndSubCatNavTN,
} from "../../../components/AdminComponents/MenuItems";

import "../tableStyling.css";

import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import { message } from "antd";
import { useLocation } from "react-router-dom";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import CatSubCatCourseModal from "../CAAdminCoursePages/CatSubCatCourseModal";
import CategoryParent from "../../../components/AdminComponents/Modals/CategoryParent";
import axiosInstance from "../../../api/Axios";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { useSelector } from "react-redux";
import { accessImpersontate } from "../../../config";
// import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";

const CatAndSSubCatTesting = () => {
  //console.log(props.manager);
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  //   const [top, setTop] = useState(false);
  const userInfo = useSelector((state) => state.user);
  // Original code - commented out to allow access in production when impersonating
  // const ImpersonateAccess = !accessImpersontate(
  //   userInfo?.data?.impersonate_acc
  // );
  // Always allow access for Topics section
  const ImpersonateAccess = true;
  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };
  // const handleParentRowClose = (key) => {
  //   setExpandedRows({
  //     ...expandedRows,
  //     [key]: true,
  //   });
  // };
  // const [secondRowIndex, setsecondRowIndex] = useState(-1);
  // const setRowSecond = (index) => {
  //   setsecondRowIndex(index);
  // };
  //

  // eslint-disable-next-line no-unused-vars

  // const data = [
  //   {
  //     key: "0",
  //     name: "Screen",
  //     platform: "iOS",
  //     version: "10.3.4.5654",
  //     upgradeNum: 500,
  //     creator: "Jack",
  //     createdAt: "Willows",
  //   },
  //   {
  //     key: "1",
  //     name: "Screen 2",
  //     platform: "Android",
  //     version: "11.0.0",
  //     upgradeNum: 1000,
  //     creator: "Jane",
  //     createdAt: "Oak",
  //   },
  //   {
  //     key: "2",
  //     name: "Screen 3",
  //     platform: "Web",
  //     version: "2.1.0",
  //     upgradeNum: 200,
  //     creator: "John",
  //     createdAt: "Maple",
  //   },
  // ];

  //console.log(namingData);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [itemsLength, setItemsLength] = useState();

  // eslint-disable-next-line no-unused-vars
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/categorylist/`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, search, active, filter_url } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}&status=${
          active ? "True" : "False"
        }&${filter_url}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}&status=${
        active ? "True" : "False"
      }&${filter_url}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res.data.results);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const handleViewClick = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };
  const CreateSuccessful = (props) => {
    messageApi.open({
      type: "success",
      content: `${props}.`,
      duration: 5,
    });
    setLoading(true);
    LoadUser();
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `${props}.`,
      duration: 5,
    });
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const [top, setTop] = useState(false);
  const showModal = () => {
    setTop(true);
  };
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      {/* <SecondaryNav
        menuItems={isCAAdmin ? CatAndSubCatNav : CatAndSubCatNavTN}
      /> */}
      <CommonTopDetails
        title={"Categories and Sub-Categories Summary"}
        titleSuffix={`${itemsLength || 0} items(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        // marginPass="15px"

        filterAction={false}
        filterUrl={null}
        filterButtonProps={null}
        resetButtonProps={null}
        showAddButton={ImpersonateAccess}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
      />

      {/* <div className="form-container-2"> */}
      <Spin spinning={loading}>
        <CategoryParent
          data={data}
          onShowSizeChange={onShowSizeChange}
          onPageChange={onPageChange}
          currentPage={currentPage}
          pageSize={pageSize}
          itemsLength={itemsLength}
          active={active}
          handleViewClick={handleViewClick}
          LoadUser={LoadUser}
          CreateSuccessful={CreateSuccessful}
          CreateFailed={CreateFailed}
          top={top}
          setTop={setTop}
          ImpersonateAccess={ImpersonateAccess}
        />
      </Spin>
      {/* </div> */}

      <CatSubCatCourseModal
        selectedRecord={selectedRecord}
        handleModalClose={handleModalClose}
        isModalVisible={isModalVisible}
      />
    </WrapperComponent>
  );
};

export default CatAndSSubCatTesting;
